import react, {useEffect,useState} from 'react';
import { Tooltip, message, Image as AntdImage, Empty, Tag, Popover, 
    Popconfirm, Checkbox, Pagination, Radio, Divider, Space, Modal, Result,
    Button
 } from 'antd';
import { BugOutlined, PlusCircleOutlined, PlusSquareOutlined, MinusSquareOutlined, SyncOutlined, ExceptionOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import './index.scss';
import {getCADViewUrl, getSearchParams, goKnowledgeDetails, addAICart, viewAttachment} from '../../utils/tool'
import storage from "../../utils/storage";
import Iconfont from "../Iconfont/Iconfont";
import KnowledgeFileIconV7 from "../KnowledgeFileIconV7/index";
import SelfPagination from "../SelfPagination/index";
import { refreshAIcarNumF } from "../../features/AIIntelligent/AIReducer";
import { setAIModalState, setQAKowledgeList } from "../../features/AIIntelligentV7/AIReducer";
import {readByAI, ModalConfirm, jumpToPage} from "../../utils/tool";
import ViewImg from "../ViewImg";
import Api from "../../api/index";
import aiTextIcon from '../../assets/img/V7/aiTextIcon.svg';
import openStatus from '../../assets/img/V7/openStatus.svg';
import privateStatus from '../../assets/img/V7/privateStatus.svg';
import SelfDesignModal from "../../components/SelfDesignModal";
import knowledgeDefalut from '../../assets/img/V7/knowledgeDefalut.png';
import { cadType } from "../../utils/defaultValue";

// 基础知识类型
const knowledgeTypeList = ['1','2','3','5','6','9']
const KnowledgeList = ({
    type,
    autoHight,
    paginationChange,
    pagination,
    listDate,
    getList,
    showProject,
    selecthValue,
    checkOnchange,
    checkedValue = [],
    showSelect,
    singleChoice,
    knowledgeTypeId,
    operateFunc,
    searchData
}) => {
    const isManage = getSearchParams().inlet === "manage";
    const dispatch = useDispatch();

    const [newListDate, setNewListDate] = useState([]);

    const history = useHistory();
    
    const [openZipKey, setOpenZipKey] = useState([]);

     // 图片预览列表
    const [viewImgList, setViewImgList] = useState([]);
    const [isShowViewImg, setIsShowViewImg] = useState(false);
    const [viewImgIdx, setViewImgIdx] = useState(0);

    // AI购物车数量变化
    const refreshAIcarNum = useSelector(state => state.AIModal.refreshAIcarNum);

    const QAKowledgeList = useSelector(state => state.AIReducerV7.QAKowledgeList);

    const [showEnterStyle, setShowEnterStyle] = useState(null);


    // 个人资料
    const [isBatch, setIsBatch] = useState(null); // 是否批量操作
    const [showTipsModal, setShowTipsModal] = useState(false); //分享的确认操作框
    const [editFileVlue, setEditFileVlue] = useState({}); // 需要编辑的知识
    const [moveOrCopyId, setMoveOrCopyId] = useState(null); // 移动或者复制 选中的知识id
    const [spaceTree, setSpaceTree] = useState([]); // 空间分类tree 弹窗
    const [spaceTreeIsShow, setSpaceTreeIsShow] = useState(false); // 空间分类tree 弹窗
    const [selectedTreeIds, setSelectedTreeIds] = useState([]); // 选中的空间分类tree
    const [operateType, setOperateType] = useState(null);

    const [smallScreen, setSmallScreen] = useState(false);

    useEffect(() => { 
        handleResize();

        // 添加事件监听器
        window.addEventListener('resize', handleResize);

        // 组件卸载时移除事件监听器
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    useEffect(()=>{
        setNewListDate(listDate)
    },[JSON.stringify(listDate)])

    // AI购物车数量变化 - 刷新列表
    useEffect(()=>{
        if(getList && refreshAIcarNum){
            getList();
        }
    },[refreshAIcarNum])

    const handleResize = () => {
        console.log(`Window size: ${window.innerWidth} x ${window.innerHeight}`);
        if(window.innerWidth < 1500){
            setSmallScreen(true);
        }else{
            setSmallScreen(false);
        }
    }; 

    const updateMangerTreeData = (list, key, children) =>{
        let list1 = list.map((node) => {
            if (node.id === key) {
                node = {
                    ...node,
                    childList:children,
                }
              return node
            }
            if (node.childList) {
              return {
                ...node,
                childList: updateMangerTreeData(node.childList, key, children),
              };
            }
            return node;
        });
        return list1;
    }


    const goKnowledgeList = (item) => {
        history.push(`/page/knowledgeContent?type=knowledge&id=${item.knowledgeTypeId}`);
    }

    const goProjectId = (item) => {
        history.push(`/page/knowledgeContent?type=knowledge&id=2&projectId=${item.projectId}`);
    }


    const getListItemContent = (item) => {
        let content = "";
        
        if(getSearchParams().inlet === "manage" || type === "researchReport" || type === "generalKnowledge" || type === "publicModal"){
            content = ""
        }else if(type==='ES' && item.knowledgeTypeId === '4'){
            // 政策运维
            content = item.isManual === 1?(
                <div title={item.content} className="listItemContent" dangerouslySetInnerHTML={{__html:
                    item.content
                }} />
            ):(
                <div title={item.content} className="listItemContent" dangerouslySetInnerHTML={{__html:
                    item.content
                }} />
            )
        }else{
            let html = item.knowledgeDigest ? item.knowledgeDigest : '';

            if(type === 'ES' && selecthValue === '1'){
                // ES搜索全文
                // selecthValue === 1 全文
                html = item.knowledgeMainBody
            }else if(searchData && searchData.knowledgeName){
                // 知识中心
                // 有搜索参数的时候，显示全文字段
                html = item.knowledgeMainBody
            }
            
            let _title = html;
            if(html){
                _title = html.replace(/<font color='red'>|<\/font>/g, "");
            }
            content = (
                <div className="listItemContent" title={_title} dangerouslySetInnerHTML={{__html:html}} />
                // <div className="listItemContent" title={_title}>{html}</div>
            )
        }

        return content
    }

    const getListTime = (item) => {
        let content = "";
        if(getSearchParams().inlet === "manage"){
            content = (<div className="releaseTime">发布于 {item.createTime}</div>)
        }

        return content
    }


    const getListTitle = (item) =>{
        let content = "";
        if(type==='ES'){

            if(item.knowledgeTypeId === '4'){
                // 政策运维
                content = (
                    <div className="listTitle" dangerouslySetInnerHTML={{__html:
                        item.title
                    }} />
                )
            }else{
                content = (<div className="listTitle" dangerouslySetInnerHTML={{__html: item.knowledgeTitle}} />)
            }

        }else if(type==='home' || getSearchParams().inlet === "manage"){
            content = (<div className="listTitle" title={item.knowledgeName}>{item.knowledgeName}</div>)
        }else{
            let text = item.knowledgeTitle || item.knowledgeName;
            content = (<div className="listTitle" title={text} dangerouslySetInnerHTML={{__html: text}}/>)
        }
        return content
    }


    const getProjectName = (item) =>{
        let content = "";
        if(
            item.knowledgeTypeId === '2' ||
            showProject
        ){
            content = (<span className="listDetailTitle" 
            // onClick={()=>goProjectId(item)}
            >
            <Tooltip title={item.projectName} placement="topLeft">
                <span className="jumpPointer">{item.projectName||"--"}</span>
            </Tooltip>
            <Divider type="vertical" />
            </span>)
        }
        return content
    }

    const getReadNum = (item) =>{
        let content = "";
        if(
            getSearchParams().inlet != "manage"
        ){
            let knowledgeReadNum = item.knowledgeReadNum ? item.knowledgeReadNum : 0;
            content = (<span>{type==='home'? item.readNum : knowledgeReadNum}次阅读<Divider type="vertical" /></span>)
        }
        return content
    }

    const getAuthors = (item) =>{
        /* 6 参考资料；7 参考研报 时没有作者，只有知识来源*/
        let content = "";
        let iStyle = (item.knowledgeTypeId === '2' || item.subclassification) ? {maxWidth: 60} : {maxWidth: 60}

        // 自定义作者
        let custonAuthor = []
        if(item.nameExts && item.nameExts.length > 0){
            item.nameExts.map(item => {
                custonAuthor.push(item)
            })
        }

        if(
            getSearchParams().inlet === "manage"
        ){
            let userName = item.knowledgeSource;
            if((item.knowledgeTypeId != '6' && item.knowledgeTypeId != '7' )){
                userName = [];
                if(item.authors){
                    item.authors.map(item=>{
                        userName.push(item)
                    })
                }
            }

            if(Array.isArray(userName)){
                userName = [...userName,...custonAuthor].toString()
            }

            content = (<span>
                <Tooltip title={userName} placement="topLeft">
                    <span className="authorBox" style={iStyle} title={userName}>{userName}</span>
                </Tooltip>
                <Divider type="vertical" />
            </span>)
        }else if(type==='ES'){
            let author = item.knowledgeSource;
            if((item.knowledgeTypeId != '6' && item.knowledgeTypeId != '7' )){
                author = item.author
            }

            let authorsTitle = [];
            if(item.authors){
                item.authors.map(item=>{
                    authorsTitle.push(item)
                })
            }

            if(Array.isArray(authorsTitle)){
                authorsTitle = [...authorsTitle,...custonAuthor].toString()
            }

            {/* ES搜索作者时返回的author会带html结构，改为 authors 显示title*/}
            content = (<span>
                <Tooltip title={authorsTitle} placement="topLeft">
                <span className="authorBox" dangerouslySetInnerHTML={{__html: author}}></span>
                </Tooltip>
                <Divider type="vertical" />
            </span>)
        }else{
            let authors = item.knowledgeSource;
            // 6参考资料 7参考研报
            
            if((item.knowledgeTypeId != '6' && item.knowledgeTypeId != '7' )){
                authors = (item.authors && item.authors.length>0) ? item.authors.toString(): item.authors
            }

            if(Array.isArray(authors)){
                authors = [...authors,...custonAuthor].toString()
            }

            if(authors){
                content = (<span>
                <Tooltip title={authors} placement="topLeft">
                    <span className="authorBox" style={iStyle}>{authors}</span>
                </Tooltip>
                <Divider type="vertical" />
                </span>)
            }
            
        }
        return content

    }

    const getSubclassification = (item) => {
        let content = "";

        content = (
            <span>
                <span className="subclassification" title={item.subclassification}>{item.subclassification}</span>
                <Divider type="vertical" />
            </span>
        )

        return content
    }

    const openZipList = (item, knowledgeId) => {
        let _openZipKey = [...openZipKey];

        if(_openZipKey.includes(knowledgeId)){
            let newOpenZipKey = _openZipKey.filter((id)=>id != knowledgeId);

            setViewImgList([]);
            setOpenZipKey(newOpenZipKey)
        }else{
            let urlList = [];

            item.childList.map((childItems,index)=>{
                if(childItems.fileUrl){
                    urlList.push({
                        url:childItems.fileUrl,
                        name:childItems.knowledgeName,
                        id:index
                    })
                }
            })

            setViewImgList([...urlList]);

            _openZipKey.push(knowledgeId)
            setOpenZipKey(_openZipKey)
        }
    }

    const getChildrenList = (item) => {

        return(
            <div className={`${type === 'home' ? "childrenlistBoxH": "childrenlistBox"}`}>
                {item.childList.map((childItem,index)=>{

                    if(childItem.fileUrl){
                        childItem.id = index
                    }

                    return(
                        <div className="childrenlistItemHeader"
                            onClick={()=>{

                                if(cadType.includes(childItem.fileType) || cadType.includes(childItem.type)){
                                    let url = `${getCADViewUrl()}?saToken=${storage.getItem("token")}&fileId=${childItem.id}`;
                                    window.open(url);
                                }else if(childItem.fileUrl){
                                    setViewImgIdx(childItem.id);
                                    setIsShowViewImg(true);
                                }else if(childItem.id){
                                    goKnowledgeDetails({
                                        ...item,
                                        type,
                                        selecthValue
                                    },childItem)
                                }else{
                                    message.info("当前文件类型不支持")
                                }
                            }}
                        >
                            {/* 文件图标 */}
                            <KnowledgeFileIconV7
                                fileType={childItem.fileType}
                                isPic={childItem.isPic}
                            />

                            {/* 标题 */}
                            <div className="listTitle" title={childItem.knowledgeName}>{childItem.knowledgeName}</div>
                        </div>
                    )
                })}
            </div>
        )
    }

    // 添加知识到AI购物车
    const addKnowledgeToAICart = async (knowledgeIds) => {
        const res = await addAICart(knowledgeIds);
        if(res){
            let _newListDate = [...newListDate]
            _newListDate.map(item=>{
                let knowledgeId = item.id || item.knowledgeId || item.policyId || item.elasticId;
                if(knowledgeIds.includes(knowledgeId)){
                    item.addCartStatus = 1;
                }
            })
            dispatch(refreshAIcarNumF(Date.now().toString()))
            setNewListDate(_newListDate)
        }
    }
    // AI帮我读
    const readKnowledgeByAI = (item) => {
        readByAI(item, history)
    }

    const addAIQA = (item) => { 
        let newItem = {...item};
        newItem.knowledgeTitle = newItem.knowledgeTitle ? newItem.knowledgeTitle.replace(/<font color='red'>|<\/font>/g, ""): newItem.knowledgeTitle;
        newItem.knowledgeName = newItem.knowledgeName ? newItem.knowledgeName.replace(/<font color='red'>|<\/font>/g, ""): newItem.knowledgeName;
        newItem.title = newItem.title ? newItem.title.replace(/<font color='red'>|<\/font>/g, ""): newItem.title;

        dispatch(setQAKowledgeList([
            ...QAKowledgeList,
            newItem
        ]))
    }



    // 取消收藏
    const showModal = (id) => {
        ModalConfirm({
          title: "确定取消收藏这条知识吗？",
          onOk: async (resolve, reject) => {
            try {
              let res = await Api.PersonalCenter.cancleCollection({
                data: { id },
              });
              if (res.data && res.data.code === 0) {
                message.success("取消收藏成功");
                dispatch(setAIModalState({
                    "refreshSpaceList": new Date().getTime()
                }))
              }
              resolve();
            } catch {}
          },
        });
    };

    const moreAttachmentList = (items) => {
        let key = items.id;
        let _newListDate = [...newListDate]
        _newListDate.map(item=>{
            let id = item.id;
            if(id === key){
                item.moreOpen = !item.moreOpen
            }
        })
        setNewListDate(_newListDate)
    }


    return (
        <div className="knowledgeListFrameV7">
            {newListDate && newListDate.length > 0 ? (
                <div 
                className="listBox" 
                id={"listBox"} 
                style={autoHight && {
                    maxHeight: ((getSearchParams().inlet === "manage" ? autoHight+20 : autoHight) - 32) || 0,
                }}>

                    {newListDate.map(item => {
                        let knowledgeId = item.id || item.knowledgeId || item.policyId || item.elasticId;


                        const {knowledgeCheckStatus, id, updateStatus} = item;
                        let params = [item];
                        const status = String(knowledgeCheckStatus);
                        const isShared = status === "1";
                        const isShowUpdate = isShared || status === "2";
                        const operateTypeList = [
                            {key: "share", text: "分享",},
                            {key: "edit", text: "补充文章信息",},
                            {key: "copy", text: "复制到…",},
                            {key: "move", text: "移动到…",},
                            {key: "history", text: "历史版本",},
                        ];
                        if (isShowUpdate) {
                            operateTypeList.shift();
                            operateTypeList.shift();
                            if (isShared) {
                                operateTypeList.unshift({key: "update", text: "更新",},)
                            }
                        }

                        return(<div key={knowledgeId} className={`listItem ${showEnterStyle === knowledgeId ? 'hoverClass' : ''}`}
                            onMouseEnter={(e) => {
                                if(showSelect){
                                    setShowEnterStyle(knowledgeId)
                                }
                            }}
                            onMouseLeave={(e) => {
                                if(showSelect){
                                    setShowEnterStyle(null)
                                }
                            }}
                        >
                            <div className="listItemContentBox">
                                <div className="listItemContentLeft">
                                    <div className="listItemContentTitle" onClick={()=>{
                                        if(getCADViewUrl() && cadType.includes(item.fileType)){
                                            let url = `${getCADViewUrl()}?saToken=${storage.getItem("token")}&fileId=${item.id}`;
                                            window.open(url);
                                        }else if(knowledgeTypeId === "personalData"){
                                            if(item.knowledgeCheckStatus === 1 ){
                                                jumpToPage(item); 
                                            }else{
                                                let url = `/page/newKnowledge?knowledgeId=${item.id}&type=view`;
                                                window.open(url);
                                            }
                                        }else if(type != "publicModal" && !showSelect){
                                            goKnowledgeDetails({
                                                ...item,
                                                type,
                                                selecthValue
                                            })
                                        }
                                    }}>
                                        <div className="listItemHeader">
                                            {(showSelect && singleChoice )?<Radio
                                                value={item.id}
                                                onClick={(e) => e.stopPropagation()}
                                                onChange={(e)=>checkOnchange(e,"radio")}
                                                checked={checkedValue.includes(item.id)}
                                                style={{marginRight: '0.4rem'}}
                                                // className='radioCheckbox'
                                                // disabled={showSelect ? item.cartStatus != 0 : false }
                                            ></Radio>:(type === "publicModal" || showSelect) && <Checkbox
                                                value={item.id}
                                                onClick={(e) => e.stopPropagation()}
                                                onChange={(e)=>checkOnchange(e,"checkbox")}
                                                checked={checkedValue.includes(item.id)}
                                                // disabled={showSelect ? item.cartStatus != 0 : false }
                                                style={{marginRight: '0.4rem'}}
                                                // showSelect 的时候是AI选择公共知识，
                                                // cartStatus = 0 表示AI同步完成，才可以选择
                                            ></Checkbox>}

                                            {/* 文件图标 */}
                                            <KnowledgeFileIconV7
                                                fileType={item.fileType}
                                                isPic={item.isPic}
                                            />

                                            {/* 是否是重要文件 */}
                                            {item.isImportant === 1 && <div><Iconfont type="icon-zhongyao" iStyle={{color:"rgb(240 78 78)", fontSize: '1rem'}}/></div>}

                                            {/* 是否是扫描件 */}
                                            {item.isScan === 1 && <div><Iconfont type="icon-saomiaojianshangchuan" iStyle={{color:"#1296db", fontSize: '1rem'}}/></div>}
                                            

                                            {/* 标题 */}
                                            {getListTitle(item)}
                                            

                                            {/* AI */}
                                            {/* 基础知识-不是在线文档，必须解析完成才能加入问答 */}
                                            {/* 政策和研报，都可以加入 */}
                                            {
                                                ((knowledgeTypeList.includes(item.knowledgeTypeId) &&
                                                item.fileType != "online" &&
                                                String(item.cartStatus) === '0') || 
                                                (!knowledgeTypeList.includes(item.knowledgeTypeId)) && item.fileType != "online") && 
                                                
                                                <Tooltip 
                                                    title="加入解析栏"
                                                >
                                                    <div onClick={(e)=>{e.stopPropagation();addAIQA(item)}}><PlusCircleOutlined /></div>
                                                </Tooltip>
                                            }

                                            {/* ZIP展开按钮 */}
                                            {item.fileType === 'zip' && item.childList &&
                                                <>{openZipKey.includes(knowledgeId)?
                                                    <Tooltip  title="收起">
                                                        <div><MinusSquareOutlined
                                                            className="openZipIcon"
                                                            onClick={(e)=>{
                                                                openZipList(item,knowledgeId);
                                                                e.stopPropagation();
                                                            }}
                                                        /></div>
                                                    </Tooltip>:
                                                    <Tooltip  title="查看更多文件">
                                                        <div><PlusSquareOutlined
                                                            className="openZipIcon"
                                                            onClick={(e)=>{
                                                                openZipList(item,knowledgeId);
                                                                e.stopPropagation();
                                                            }}
                                                        /></div>
                                                    </Tooltip>
                                                }</>
                                            }

                                            {/* 发布时间 */}
                                            {getListTime(item)}
                                        </div>

                                        {/* 标签 */}
                                        {item.lables&&item.lables.length>0&&
                                        <div className="tagList">
                                            {item.lables.map(items=>
                                            <div className="tagItem">{items}</div>
                                            )}
                                        </div>
                                        }

                                        {/* 摘要 */}
                                        {getListItemContent(item)}

                                    </div>

                                    <div className="listItemFooter">

                                        {/* ES搜索下的政策运维 */}
                                {
                                    (type==='ES' && item.knowledgeTypeId === '4') ? (
                                        <div className="listItemFooterItem">
                                            <Space size={"large"}>
                                                <span>
                                                发文机构：<span className="jumpPointer">{item.source || "--"}</span>
                                                </span>

                                                <span>
                                                发文字号：<span className="jumpPointer">{item.docNum || "--"}</span>
                                                </span>

                                                <span>发文时间：{item.time || "--"}</span>

                                            </Space>
                                        </div>
                                    ) : (

                                        <div className="listItemFooterItem">

                                            {/* 个人资料显示文件分享状态 */}
                                            {knowledgeTypeId === "personalData"&&<div className="statusBox">

                                                {   String(item.updateStatus) === '1' ? <Tag icon={<SyncOutlined spin />} color="processing">更新中</Tag> :
                                                    item.knowledgeCheckStatus === 0 ? <Tag icon={<Iconfont type={"icon-cuowu"} />} color="error">已拒绝</Tag> :
                                                        item.knowledgeCheckStatus === 1 ? <Tag icon={<Iconfont type={"icon-dui"} />} color="success">公开</Tag> :
                                                            item.knowledgeCheckStatus === 2 ? <Tag icon={<SyncOutlined spin />} color="processing">审批中</Tag> :
                                                            <Tag icon={<Iconfont type={"icon-yuandian"} />} color="cyan">私密</Tag>
                                                }
                                            </div>}


                                            {/* 知识类型 */}
                                            {item.knowledgeTypeName&&<>
                                            <span className="listDetailTitle">
                                                {item.knowledgeTypeName}
                                            </span>
                                            <Divider type="vertical" />
                                            </>}
                                            
                                            {/* 经典案例显示项目 */}
                                            {/* {getProjectName(item)} */}

                                            {/* 作者 */}
                                            {getAuthors(item)}

                                            {/* 创建时间 */}
                                            {item.createTime && <>
                                                <span>{item.createTime}</span>
                                                <Divider type="vertical" />
                                            </>}
                                            

                                            {/* 所属分类 */}
                                            {item.subclassification&&getSubclassification(item)}
                                            

                                            {/* 阅读次数 */}
                                            {getReadNum(item)}

                                            {/* 进入详情 */}
                                            {/* 普通知识，不是在线文档，并且解析完成 */}
                                            {
                                            (knowledgeTypeList.includes(item.knowledgeTypeId) &&

                                                item.fileType != "online" &&

                                                String(item.cartStatus) === '0')&&

                                            <div className="aiTextIcon"  onClick={()=>{
                                                goKnowledgeDetails({
                                                    ...item,
                                                    type,
                                                    selecthValue
                                                })
                                            }}>
                                                <AntdImage
                                                    src={aiTextIcon}
                                                    preview={false}
                                                />
                                                <span>速读文本</span> 
                                            </div>}
                                            
                                            {/* 参考研报是否是爬虫数据 */}
                                            {(item.knowledgeTypeId === '7' && item.sourceType===1) ? <div className="bugIcon">
                                                <Divider type="vertical" />
                                                <BugOutlined />
                                            </div> : ""}
                                            

                                            {/* 个人资料的操作 */}
                                            {knowledgeTypeId === "personalData"&&
                                            <Popover
                                                // open={moreShowId === id}
                                                placement="leftTop"
                                                // getPopupContainer={knowledgeList.length > 8 ? () => document.getElementById(id) : null}
                                                content={(
                                                    <div className="mySpaceTableMoreOperateBox moreOperateBox">
                                                        {
                                                            operateTypeList.map(item => {
                                                                const {key, text} = item;
                                                                return (
                                                                    <span key={`${id}-${key}`} className="operateBtn" onClick={() => operateFunc(key, params, false)}>{text}</span>
                                                                )
                                                            })
                                                        }
                                                        <Popconfirm
                                                            placement={"left"}
                                                            title={(<span><Iconfont type='icon-tishi' iStyle={{color: "#ff981e", marginRight: "0.2rem", top: "-0.1rem"}} />确定下载所选择的知识吗？</span>)}
                                                            okText={"确定"}
                                                            cancelText={"取消"}
                                                            overlayClassName="deletePupConfirmBox"
                                                            onConfirm={() => operateFunc("download", params, false)}
                                                            getPopupContainer={() => document.getElementById(`${id}-downloadBtn`)}
                                                        >
                                                            <span
                                                                className="operateBtn downloadBtn"
                                                                id={`${id}-downloadBtn`}
                                                                onClick={(e) => {
                                                                    e?.stopPropagation();
                                                                    e?.preventDefault();
                                                                }}
                                                            >下载</span>
                                                        </Popconfirm>
                                                        {
                                                            !isShowUpdate && (
                                                                <Popconfirm
                                                                    placement={"left"}
                                                                    title={(<span><Iconfont type='icon-fail' iStyle={{color: "#F53F3F", marginRight: "0.2rem", top: "-0.1rem"}} />确定删除所选择的知识吗？</span>)}
                                                                    okText={"确定"}
                                                                    cancelText={"取消"}
                                                                    overlayClassName="deletePupConfirmBox"
                                                                    onConfirm={() => operateFunc("delete", params, false)}
                                                                    getPopupContainer={() => document.getElementById(`${id}-deleteBtn`)}
                                                                >
                                                                    <span
                                                                        className="operateBtn deleteBtn"
                                                                        id={`${id}-deleteBtn`}
                                                                        onClick={(e) => {
                                                                            e?.stopPropagation();
                                                                            e?.preventDefault();
                                                                        }}
                                                                    >删除</span>
                                                                </Popconfirm>
                                                            )
                                                        }
                                                    </div>
                                                )}
                                                title={null}
                                            >
                                                <Divider type="vertical" />
                                                <span
                                                    className="operateBtn moreBtn"
                                                    id={id}
                                                    onClick={(e) => {
                                                        e?.stopPropagation();
                                                        e?.preventDefault();
                                                    }}
                                                >操作</span>
                                            </Popover>}

                                            {/* 专题收藏的操作 */}
                                            {knowledgeTypeId === "collection"&&
                                            <>
                                                <Divider type="vertical" />
                                                <Popover
                                                    placement="left"
                                                    content={(
                                                        <div className="mySpaceTableMoreOperateBox moreOperateBox">
                                                            <span key={id} className="operateBtn" onClick={()=>showModal(knowledgeId)}>取消收藏</span>
                                                        </div>
                                                    )}
                                                    title={null}
                                                >
                                                    <span
                                                        className="operateBtn moreBtn"
                                                        id={id}
                                                        onClick={(e) => {
                                                            e?.stopPropagation();
                                                            e?.preventDefault();
                                                        }}
                                                    >操作</span>
                                                </Popover>
                                            </>
                                            }


                                        </div>
                                    )}
                                    </div>
                                </div>
                                <div className="listItemContentRight" style={smallScreen?{width: '10rem'}:{width: '12rem'}}>
                                    <img src={item.thumbFileUrl || knowledgeDefalut} />
                                </div>
                            </div>

                            {/* ZIP下的文件列表 */}
                            {openZipKey.includes(knowledgeId)&&item.childList&&item.childList.length>0&&<>
                                {getChildrenList(item)}
                            </>}

                            {item.policyAttachs && item.policyAttachs.length > 0 && (
                                <>
                                    <div className="attachmentList" style={
                                        item.moreOpen ? {height: 'auto'} : 
                                        item.policyAttachs.length === 1 ? {height: '35px'} : {height: '70px'}
                                        }>
                                        {item.policyAttachs.map((items, index) => {
                                            return <div className="attachmentListItem"
                                                onClick={()=>viewAttachment(items)}
                                            >
                                                <div className="fileIconclassName">
                                                    <KnowledgeFileIconV7 fileType={items.fileType} />
                                                    附件{index+1}：
                                                </div>
                                                <div className="attachmentName" dangerouslySetInnerHTML={{__html: items.attachmentName}}></div>
                                            </div>
                                        })}
                                    </div>
                                    {item.policyAttachs.length > 2 &&<div className="moreAttachmentList" onClick={(e)=>{
                                        e.stopPropagation();
                                        moreAttachmentList(item)
                                    }}>
                                        {item.moreOpen ? <><Iconfont type={'icon-shangjiantou4'}/>收起</> :<><Iconfont type={'icon-xiala'}/>更多</>}
                                    </div>}
                                </>
                            )}

                        </div>)
                    })}
                </div>
             ):<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}

             {pagination && (newListDate && newListDate.length > 0)?(<div className="pagination">
                 <div className="paginationFrame">
                    <Pagination
                        current={pagination.pageIndex}
                        total={pagination.total}
                        pageSize={pagination.pageSize}
                        onChange={paginationChange}
                        showSizeChanger={true}
                        showQuickJumper={true}
                        showTotal={(total) => `总计${total}条数据`}
                        size={"small"}
                    />
                </div>
            </div>):""}
            

            <ViewImg
                viewImgList={viewImgList}
                isShowViewImg={isShowViewImg}
                viewImgIdx={viewImgIdx}
                closeViewImg={() => setIsShowViewImg(false)}
            />


        </div>
    )
}

export default KnowledgeList;
